import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { QuestionnaireDetailsService } from './../../../../service/questionnaire/questionnaire.service';
import { AppMainService } from './../../../../app-main.service';
import { AppMainComponent } from './../../../../app.main.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Status } from './../../../../models/statusEnums';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-questionnaire-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss']
})
export class CrmQuestionnaireQuestionsComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayQuestionAdd: boolean = false;
    @Output() closeDialog = new EventEmitter();

    //Questions
    tableShowMore: number[] = [15, 30, 50, 100];
    questionnaireQuestions: any[] = [];
    isActiveForQuestion: boolean = true;
    addEditQuestionnaireHeader: string = "Add Question";

    displayAddEditQuestions: boolean = false;
    selectedQuestionId: any;
    questionTemp: any = null;
    answerTypes: any[] = [];
    selectedAnswerType: any;
    questionData: any;
    openConfirmationDialog: boolean = false;

    constructor(
        private app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private confirmationService: ConfirmationService,
        private questionnaireDetailsService: QuestionnaireDetailsService
    ) { }

    ngOnInit(): void {
        this.questionTemp = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "name": "",
            "questionName": "",
            "description": "",
            "organizationId": this.app.user.organizationId,
            "formControlId": 0,
            "displayOrder": 0,
            "questionOptionId": 0,
            "isValid": true,
            "validFromDate": "2021-06-02T18:52:25.997Z",
            "validToDate": "2021-06-02T18:52:25.997Z",
            "statusId": 1,
            "questionOptions": [] as any[],
            "questionPreDefinedInputAnswers": [] as any[],
            "subQuestions": []
        }
        this.getAnwserTypes();
        this.getQuestions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['displayQuestionAdd'] && changes['displayQuestionAdd'].currentValue){
            this.showAddQuestion();
        }
    }

    getAnwserTypes(){
        this.questionnaireDetailsService.getallAnswerTypes().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(c => {
            this.answerTypes = c;
        });
    }

    getQuestions() {
        this.questionnaireDetailsService.getallQuestionnaireQuestions(this.isActiveForQuestion).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                const questions = response || [];
                if (this.isActiveForQuestion) {
                    this.questionnaireQuestions = questions?.filter(ques => ques.statusId === 1);
                } else {
                    this.questionnaireQuestions = questions?.filter(ques => ques.statusId === 2);
                }
            },
            error: (error) => {

            }
        });
    }

    showAddQuestion() {
        this.addEditQuestionnaireHeader = "Add Question";
        this.questionTemp.questionPreDefinedInputAnswers = [];
        this.displayAddEditQuestions = true;
        this.questionTemp = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "name": "",
            "questionName": "",
            "description": "",
            "organizationId": this.app.user.organizationId,
            "formControlId": 0,
            "displayOrder": 0,
            "questionOptionId": 0,
            "isValid": true,
            "validFromDate": "2021-06-02T18:52:25.997Z",
            "validToDate": "2021-06-02T18:52:25.997Z",
            "statusId": Status.Active,
            "questionOptions": [] as any[],
            "questionPreDefinedInputAnswers": [] as any[],
            "subQuestions": []
        }
    }

    addQuestionnaireSubQuestion(questionObj, questionData) {
        this.questionTemp = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "name": "",
            "questionName": "",
            "description": "",
            "organizationId": this.app.user.organizationId,
            "formControlId": 0,
            "displayOrder": 0,
            "questionPreDefinedAnswerId": 0,
            "isValid": true,
            "validFromDate": "2021-06-02T18:52:25.997Z",
            "validToDate": "2021-06-02T18:52:25.997Z",
            "statusId": Status.Active,
            "questionPreDefinedAnswers": [],
            "questionPreDefinedInputAnswers": [],
            "subQuestions": []
        }

        const subQuestionsAvailable = questionObj.subQuestions.filter(s => s.questionPreDefinedAnswerId == questionData.id);
        if (subQuestionsAvailable.length > 0) {

            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Sub-Question already added for this answer...' });
        } else {
            this.questionData = questionData;
            this.addEditQuestionnaireHeader = "Add Sub Question"
            this.displayAddEditQuestions = true;
        }

    }

    checkSubQuestionAvailability(questionObj, questionData) {
        const subQuestionsAvailable = questionObj.subQuestions.filter(s => s.questionPreDefinedAnswerId == questionData.id);
        if (subQuestionsAvailable.length > 0) {
            return false;

        } else {
            return true;
        }
    }

    showEditQuestion(c) {
        this.addEditQuestionnaireHeader = "Edit Question";
        this.selectedQuestionId = ParseHelper.DeepCopy(c);
        this.questionTemp = ParseHelper.DeepCopy(c);
        this.questionTemp.isValid = this.questionTemp.statusId === 1 ? true : false;
        this.questionTemp.questionName = this.questionTemp.name;
        this.questionTemp.questionOptions = this.questionTemp?.questionOptions||[];
        this.questionTemp.questionOptions.forEach(element => {
            element.preDefinedAnswerInput = element.value;
        });
        this.questionTemp.questionPreDefinedInputAnswers = this.questionTemp.questionOptions;
        this.selectedAnswerType = this.questionTemp.formControlId && this.questionTemp.formControlId > 0 ? this.answerTypes.filter(elem => elem.id === this.questionTemp.formControlId)[0] : this.answerTypes[0];

        this.displayAddEditQuestions = true;
    }

    showEditSubQuestion(c) {
        this.addEditQuestionnaireHeader = "Edit Sub Question";
        this.questionTemp = ParseHelper.DeepCopy(c);
        this.questionTemp.isValid = this.questionTemp.statusId === 1 ? true : false;
        this.questionTemp.questionName = this.questionTemp.name;
        this.questionTemp.questionOptions = this.questionTemp?.questionOptions||[];
        this.questionTemp.questionOptions.forEach(element => {
            element.preDefinedAnswerInput = element.value;
        });
        this.questionTemp.questionPreDefinedInputAnswers = this.questionTemp.questionOptions;
        this.selectedAnswerType = this.questionTemp.formControlId && this.questionTemp.formControlId > 0 ? this.answerTypes.filter(elem => elem.id === this.questionTemp.formControlId)[0] : this.answerTypes[0];
        this.displayAddEditQuestions = true;
    }

    saveEditQuestion(c) {
        c.statusId = c.isValid ? 1 : 2;
        c.name = c.questionName;
        c.questionPreDefinedInputAnswers.forEach(element => {
            element.value = element.preDefinedAnswerInput;
        });
        c.questionOptions = c.questionPreDefinedInputAnswers;
        if(this.selectedAnswerType.name == 'ToggleButton' && this.questionTemp.questionOptions.length < 2){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Two options value required for selected Answer Type...' });
        }else if ((this.selectedAnswerType.name != 'Rating' && this.selectedAnswerType.name != 'InputBox' && this.selectedAnswerType.name != 'Picture' && this.selectedAnswerType.name != 'FileUpload') && this.questionTemp.questionOptions.length < 1) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Atleast one value should be added for selected Answer Type...' });

        } else {
            c.formControlId = this.selectedAnswerType ? this.selectedAnswerType.id : 0;

            if (this.addEditQuestionnaireHeader == 'Add Sub Question') {
                c.questionOptionId = this.questionData.id;
            }

            if (this.addEditQuestionnaireHeader == "Add Question" || this.addEditQuestionnaireHeader == 'Add Sub Question') {
                this.questionnaireDetailsService.addQuestion(c).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response)=>{
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Question added successfully...' });
                        this.getQuestions();
                        this.cancelQuestionDialog();
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message||'Error occurred while saving data...' });
                    }
                });
            } else {
                this.questionnaireDetailsService.updateQuestion(c).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response)=>{
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Question updated successfully...' });
                        this.getQuestions();
                        this.cancelQuestionDialog();
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message||'Error occurred while saving data...' });
                    }
                });
            }
        }
    }

    addFormControl() {
        let formControlDataTemp = {
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date(),
            "updatedDate": new Date(),
            "id": 0,
            "value": "",
            "preDefinedAnswerInput": "",
            "questionId": this.questionTemp.id,
        }

        this.questionTemp.questionPreDefinedInputAnswers.push(formControlDataTemp)
    }

    removeFormControl() {
        this.questionTemp.questionPreDefinedInputAnswers.splice(-1, 1)
    }

    setControl() {
        this.questionTemp.questionOptions = [];
    }

    changeAnswerType() {
        this.questionTemp.questionPreDefinedInputAnswers = [];
    }

    onIsValidChange() {
        if (!this.questionTemp.isValid && this.selectedQuestionId?.statusId === 1) {
            this.validateQuestionAssociation();
        }
    }

    validateQuestionAssociation() {
        this.appMainService.isShowSpinner('associatedQuestion')
        this.questionnaireDetailsService.questionAssociaton(this.selectedQuestionId.id).subscribe(
            {
                next: (response) => {
                    this.openConfirmationDialog = response.associationStatus;
                    this.appMainService.isHideSpinner('associatedQuestion');
                    this.openQuestionConfirmationDialog();
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    openQuestionConfirmationDialog() {
        if (this.openConfirmationDialog) {
            this.confirmationService.confirm({
                message: `The question you're trying to in-activate is associated with a Questionnaire(s), are you sure?`,
                header: 'Confirmation',
                icon: "pi pi-info-circle",
                accept: () => {
                },
                reject: () => {
                    this.questionTemp.isValid = true;
                }
            });
        }
    }

    deleteQuestion(c: any) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Question?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.questionnaireDetailsService.deleteQuestion(c.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response)=>{
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Question Deleted Successfully...' });
                        this.getQuestions();
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message });
                    }
                });
            },
            reject: () => {
            }
        });
    }

    cancelQuestionDialog() {
        this.closeDialog.emit(true);
        this.displayAddEditQuestions = false;
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

}
